/* RESPONSIBLE TEAM: team-proactive-support */
import { helper as buildHelper } from '@ember/component/helper';
export function sub(params) {
  return params.reduce((a, b) => a - b);
}

export default buildHelper(sub);
